/**
 * @generated SignedSource<<aec58c893788747e525256fedd2f7637>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksPlusArticleLinkHandlerArticle$data = {
  readonly entityId: string;
  readonly id: string;
  readonly urlAlias: string;
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckCanShowInPlusPlatformContent">;
  readonly " $fragmentType": "hooksPlusArticleLinkHandlerArticle";
};
export type hooksPlusArticleLinkHandlerArticle$key = {
  readonly " $data"?: hooksPlusArticleLinkHandlerArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksPlusArticleLinkHandlerArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "hooksPlusArticleLinkHandlerArticle"
};

(node as any).hash = "870c9ff0f67731d0cddac2038874a64e";

export default node;
